module.exports = __webpack_public_path__ + "img/bx-b.ba05b326.png";